const AppFlowActions = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_COMPLETE: 'LOGIN_COMPLETE',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',

  GET_ALL_DATA_REQUEST: 'GET_ALL_DATA_REQUEST',
  GET_ALL_DATA_COMPLETE: 'GET_ALL_DATA_COMPLETE',

  RELOAD_PAGE_REQUEST: 'RELOAD_PAGE_REQUEST',
  DISPLAY_LOADING: 'DISPLAY_LOADING',
};

export const EMITTER_CONSTANTS = {
  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  UPDATE_PROFILE: 'UPDATE_PROFILE',
};

export default AppFlowActions;


export const TABLE_CELL_TYPE = {
  INCREASE: 'INCREASE',
  DECREASE: 'DECREASE',
  TIME: 'TIME',
  HYPER: 'HYPER',
  WARNING_TAG: 'WARNING_TAG',
  DATE: 'DATE',
  BLUE: 'BLUE',
  LONG_TEXT: 'LONG_TEXT',
};


export const ROLE = {

  ADMIN: 'ADMIN',

  POWER_USER: 'POWER_USER',

  LIGHT_USER: 'LIGHT_USER',

};

export const MEASURE_SCHEDULE_TYPE_ENUM = {
  SCHEDULE_AS_SETTINGS: 'SCHEDULE_AS_SETTINGS',
  SCHEDULE_FOLLOW_HEALTH_INDEX: 'SCHEDULE_FOLLOW_HEALTH_INDEX',
};

export const statusOptions = [
  {
    label: 'Unblocked',
    value: false,
  },
  {
    label: 'Blocked',
    value: true,
  },
];

export const eStorageOptions = () => {
  const eStorageOptions = [{ value: '-1', label: 'Unlimited' }];
  for (let i = 0; i < 20; i += 1) {
    eStorageOptions.push({ value: i + 1, label: `${i + 1}` });
  }
  return eStorageOptions;
};

export const licenseTypeOptions = [
  {
    label: 'Single',
    value: 'SINGLE',
  },
  {
    label: 'Multi',
    value: 'MULTI',
  },
  {
    label: 'Omni',
    value: 'OMNI',
  },
];

export const dualESimOptions = [
  {
    label: 'Allowed',
    value: true,
  },
  {
    label: 'Not allowed',
    value: false,
  },
];

export const esimInfoENUM = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  BLOCKED: 'Blocked',
  UNBLOCKED: 'Unblocked',
  UNLIMITED: 'Unlimited',
  ALLOWED: 'Allowed',
  NOT_ALLOWED: 'Not allowed',
  DUALESIM1: 'Dual-eSIM',
  DUALESIM2: 'dualEsim',
  STATUS: 'status',
  STORAGE1: 'storage',
  STORAGE2: 'eStorage',
  STORAGE3: 'Storage',
  LICENSETYPE1: 'license_type',
  LICENSETYPE2: 'licenseType',
  IS_ALLOWED_DUAL_ESIM: 'is_allowed_dual_esim',
  LICENSE_ID: 'license_id',
  LICENSE: 'License',
};
